/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvidenceItem } from './EvidenceItem';
import {
    EvidenceItemFromJSON,
    EvidenceItemFromJSONTyped,
    EvidenceItemToJSON,
    EvidenceItemToJSONTyped,
} from './EvidenceItem';

/**
 * A score submission on the match, with source attribution (captain userId, SYSTEM telemetry, or legacy SCREENSHOT)
 * @export
 * @interface EvidenceScoreSubmission
 */
export interface EvidenceScoreSubmission {
    /**
     * 
     * @type {string}
     * @memberof EvidenceScoreSubmission
     */
    submittedBy: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceScoreSubmission
     */
    participantId: string;
    /**
     * 
     * @type {number}
     * @memberof EvidenceScoreSubmission
     */
    participant1Score: number;
    /**
     * 
     * @type {number}
     * @memberof EvidenceScoreSubmission
     */
    participant2Score: number;
    /**
     * 
     * @type {number}
     * @memberof EvidenceScoreSubmission
     */
    submittedAt: number;
    /**
     * 
     * @type {Array<EvidenceItem>}
     * @memberof EvidenceScoreSubmission
     */
    evidence?: Array<EvidenceItem>;
}

/**
 * Check if a given object implements the EvidenceScoreSubmission interface.
 */
export function instanceOfEvidenceScoreSubmission(value: object): value is EvidenceScoreSubmission {
    if (!('submittedBy' in value) || value['submittedBy'] === undefined) return false;
    if (!('participantId' in value) || value['participantId'] === undefined) return false;
    if (!('participant1Score' in value) || value['participant1Score'] === undefined) return false;
    if (!('participant2Score' in value) || value['participant2Score'] === undefined) return false;
    if (!('submittedAt' in value) || value['submittedAt'] === undefined) return false;
    return true;
}

export function EvidenceScoreSubmissionFromJSON(json: any): EvidenceScoreSubmission {
    return EvidenceScoreSubmissionFromJSONTyped(json, false);
}

export function EvidenceScoreSubmissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvidenceScoreSubmission {
    if (json == null) {
        return json;
    }
    return {
        
        'submittedBy': json['submittedBy'],
        'participantId': json['participantId'],
        'participant1Score': json['participant1Score'],
        'participant2Score': json['participant2Score'],
        'submittedAt': json['submittedAt'],
        'evidence': json['evidence'] == null ? undefined : ((json['evidence'] as Array<any>).map(EvidenceItemFromJSON)),
    };
}

export function EvidenceScoreSubmissionToJSON(json: any): EvidenceScoreSubmission {
    return EvidenceScoreSubmissionToJSONTyped(json, false);
}

export function EvidenceScoreSubmissionToJSONTyped(value?: EvidenceScoreSubmission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submittedBy': value['submittedBy'],
        'participantId': value['participantId'],
        'participant1Score': value['participant1Score'],
        'participant2Score': value['participant2Score'],
        'submittedAt': value['submittedAt'],
        'evidence': value['evidence'] == null ? undefined : ((value['evidence'] as Array<any>).map(EvidenceItemToJSON)),
    };
}

